import styled from '@emotion/styled';
import { typography } from '@landsbankinn/ui';
import { useLocalStorage } from '@landsbankinn/utils';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

const Button = styled.button`
  display: block;
  position: fixed;
  top: 22px;
  right: 32px;
  background: #fff;
  padding: 4px 16px;
  border-radius: 3px;
  z-index: 1001;
  ${typography.h5}
  cursor: pointer;
  border: 1px solid transparent;
  transition: 125ms ease-in-out;
  transition-property: border-color, box-shadow;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

  &:hover {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }
`;

export function useEditMode() {
  const router = useRouter();
  const [visible, setVisible] = useLocalStorage('edit_button', false);
  useEffect(() => {
    if (router.query && router.query.editmode) {
      setVisible(
        ['1', 'true'].includes(([] as any).concat(router.query.editmode).pop())
          ? true
          : false,
      );
    }
  }, [router.query]);
  return visible;
}

export function EditButton() {
  const editmode = useEditMode();
  const onClick = () => {
    const page = document.querySelector('[data-wio-id]');
    const id = page?.getAttribute('data-wio-id');
    window.open(
      `https://arsskyrsla.prismic.io/app/documents/${id}/ref`,
      'prismic',
    );
  };
  return editmode && <Button onClick={onClick}>Edit page in prismic</Button>;
}
